import StateController from "../../../javascript/controllers/state_controller"

const toggleElement = (arr, val) =>
  arr.includes(val) ? arr.filter(el => el !== val) : [...arr, val]

export default class extends StateController {
  static targets = [
    'channel',
    'channelGroup',
    'channelToggle',
    'platformProduct',
  ]

  state =  {
    selectedChannelIds: [],
  }

  connect(){
    this.setupState()
  }

  setupState(){
    const selectedChannelIds = []

    this.channelGroupTargets.forEach((channelGroupEl) => {
      const { dataset: { channelId, selected } } = channelGroupEl
      
      if (selected === 'true'){
        selectedChannelIds.push(Number(channelId))
      }
    })

    this.setState({
      selectedChannelIds: selectedChannelIds,
    })
  }

  toggleChannel(e){
    const { target: { dataset: { channelId } } } = e

    const isCurrentlySelected = this.state.selectedChannelIds.includes(Number(channelId))
    if (isCurrentlySelected){
      // Find Channel Group
      const channelGroup = this.channelGroupTargets.find((channelGroupEl) => {
        const { dataset: { channelId: groupChannelId } } = channelGroupEl
        return groupChannelId === channelId
      })

      // Uncheck all checkboxes in group
      const checkboxElements = channelGroup?.querySelectorAll('input[type="checkbox"]')
      if (checkboxElements){
        checkboxElements.forEach((checkboxEl) => {
          checkboxEl.checked = false
        })
      }
    }
    
    this.setState({
      selectedChannelIds: toggleElement(this.state.selectedChannelIds, Number(channelId))
    })
  }

  render() {
    const selectedChannelIds = this.state.selectedChannelIds

    // Show Channel Products
    this.channelGroupTargets.forEach((channelGroupEl) => {
      const channelId = Number(channelGroupEl.dataset.channelId)
      const isSelected = selectedChannelIds.includes(channelId)
      channelGroupEl.dataset.selected = isSelected
    })

    // Update Buttons
    this.channelToggleTargets.forEach((buttonEl) => {
      const channelId = Number(buttonEl.dataset.channelId)
      const isSelected = selectedChannelIds.includes(channelId)
      buttonEl.innerText = isSelected ? 'Disable' : 'Enable'
    })
  }
}